import axios from 'axios';

export default {
  namespaced: true,
  state: {
    setReplyForm: {
      texts: '',
      msgType: '2'
    },
    areaNum: 0,
    areadySet: false,
    isModified: false
  },
  mutations: {
    replyValidate(state, { list }) {
      if (list) {
        let { replyContent, msgType } = list;
        state.setReplyForm.texts = replyContent;
        state.setReplyForm.msgType = String(msgType);
        if (list.replyContent) {
          state.areaNum = String(replyContent).length;
          // state.areadySet = true;20190114
        } else {
          // state.areadySet = false;20190114
          state.areaNum = 0;
        }
      } else {
        state.setReplyForm = {
          texts: '',
          msgType: '2'
        };
      }
    },
    replyFailValidate(state, { list }) {
      // state.areadySet = false;20190114
      state.areaNum = 0;
    },
    setAreaNum(state, value) {
      state.areaNum = value;
    },
    setAreadySet(state, value) {
      state.areadySet = value;
    },
    setIsModified(state, value) {
      state.isModified = value;
    }

  },
  actions: {
    getReply({ commit }, params) {
      return axios.get('/wxnews/ajax/getReply', {
        params: params,
      }).then((data) => {
        commit({ type: 'replyValidate', list: data.data });
        return data;
      },
      rej => {
        commit({ type: 'replyFailValidate', list: rej.data });
      });
    },
    setReply({ commit }, params) {
      return axios.post('/wxnews/ajax/setReply', params).then((data) => {
        return data;
      });
    },
    modifyReply({ commit }, params) {
      return axios.post('/wxnews/ajax/modifyReply', params).then((data) => {
        return data;
      });
    },
    searchScanReplyRules({ commit }, params) {
      return axios.get('/wxnews/ajax/searchScanReplyRules', {
        params: params,
      }).then((data) => {
        return data;
      });
    },
    deleteScanReplyRule({ commit }, params) {
      return axios.post('/wxnews/ajax/deleteScanReplyRule', params).then((data) => {
        return data;
      });
    }
  },
};
